import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  cardLayout: {
    marginBottom: 10,
  },
  tableHeader: {
    background: 'white',
    border: '1px solid rgb(224 224 224)',
    // borderRadius: '.4rem',
    borderBottom: 'none',
    padding: '1rem .5rem',
    color: '#515151',
  },
  back_button: {
    color: 'white',
    marginRight: '2rem',
    padding: '0px',
  },
}));

export default useStyles;
